<template>
  <div>
    <base-header class="pb-6"></base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <h3 class="mb-0">Listado de Facturas</h3>
        </div>
        <div class="row starter-page">
          <div class="container-fluid">
            <vue-content-loading
              v-if="!invoice"
              :width="300"
              :height="170"
              primary="#bdc3c7"
              secondary="#95a5a6"
            >
              <svg:rect x="20" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="0" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="15" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="30" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="45" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="60" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="75" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="90" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="105" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="120" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="135" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="150" rx="3" ry="3" width="110" height="8" />
              <circle cx="206" cy="155" r="5" />
              <circle cx="219" cy="155" r="5" />
              <circle cx="232" cy="155" r="5" />
              <circle cx="245" cy="155" r="5" />
            </vue-content-loading>
            <el-table
              class="table-responsive table-flush"
              header-row-class-name="thead-light"
              row-key="id"
              :data="invoice"
              row-class-name
              v-if="invoice"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              ></el-table-column>

              <el-table-column
                min-width="80px"
                align="center"
                label="ADJUNTO"
                prop="file"
              >
                <template v-slot="{ row }">
                  <el-tooltip
                    content="VER ADJUNTO"
                    placement="top"
                    v-if="row.file"
                  >
                    <base-button type="primary" @click="showModal(row)">
                      <i class="ni ni-album-2"></i>
                    </base-button>
                  </el-tooltip>
                  <p v-else></p>
                </template>
              </el-table-column>
            </el-table>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  Mostrando {{ pagination.from }} to {{ pagination.to }} de {{ pagination.total }} registros
                </p>
              </div>
             <base-pagination
                class="pagination-no-border"
                @input="next"
                v-model="pageActual"
                :per-page="pagination.perPage"
                :total="pagination.total"
              ></base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--modal foto-->
    <CustomModal :is-modal="modals" @closeModal="modals = false" :closeOuth="true">
      <h5 class="modal-title" id="exampleModalLabel">Adjunto</h5>
      <div class="card bg-dark text-white border-0">
        <img class="card-img" :src="img_url" alt="Adjunto" />
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="modals = false"
        >Close</base-button
        >
      </template>
    </CustomModal>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip
} from "element-ui";
import axios from "axios";
import { VueContentLoading } from "vue-content-loading";
import CustomModal from "../../components/CustomModal";

export default {
  name: "ListFacturas",
  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    VueContentLoading,
    CustomModal
  },
  data() {
    return {
      pagination: {
        from: 0,
        to: 0,
        total: 0,
        page: 1,
        perPage: 0,
        totalItems: 0
      },
      modals:  false,
      img_url: null,
      currentPage: 1,
      selectedRows: [],
      tableColumns: [
        {
          prop: "date",
          label: "Fecha",
          minWidth: 100,
          sortable: true
        },
        {
          prop: "voucher_number",
          label: "Número de Comprobante",
          minWidth: 160,
          sortable: true
        },
        {
          prop: "serial_number",
          label: "Número de Serie",
          minWidth: 80,
          sortable: true
        },
        {
          prop: "delivery_time",
          label: "Hora de entrega",
          minWidth: 80,
          sortable: true
        },
        {
          prop: "amount",
          label: "Importe",
          minWidth: 100,
          sortable: true
        }
      ],
      tableData: [],
      pageActual: 1,
      invoice: [],
      baseUrl: ''
    };
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      axios.get("invoice/get?page=" + this.pageActual).then((resp) => {
        this.invoice = resp.data.data;
        this.pagination.to = resp.data.to
        this.pagination.from = resp.data.from
        this.pagination.total = resp.data.total
        this.pagination.page = this.pageActual
        this.pagination.perPage = resp.data.per_page
        this.pagination.totalItems = resp.data.totalItems
      });
    },
    showModal(row) {
      this.img_url = ''

      if(row.file.substr(-4) === '.pdf') {
        window.open(row.url, '_blank');
      }else{
        this.img_url = row.url;
        this.modals = true;
      }
    },
    next(page) {
      this.pageActual = page;
      this.invoice = []
      this.getData()
    }
  }
};
</script>

<style scoped>
.modal-dialog .modal-dialog-centered {
  max-width: 1200px !important;
}
</style>
